export default __webpack_public_path__ + "static/media/logo-mobile.85a8ae43.svg";